import { MOUSE, TOUCH } from '@/constants/userDeviceManipulatorTypes';

export * from './app';
export * from './autofill';
export * from './devices';
export * from './editorMenu';
export * from './editorMenuTabs';
export * from './endlessSizings';
export * from './main';
export * from './zoomStates';
export * from './textTypingResources';
export * from './page';
export * from './expansionPanels';
export * from './webComponent';
export * from './laserParameters';
export * from './keyboard';
export * from './dom-elements';
export * from './shapes';
export * from './application-types';

export const USER_DEVICE_MANIPULATOR_TYPE = { MOUSE, TOUCH };
export const SEPARATOR = 'separator';
export const SYMBOL_FONTS = {
  ADDITIONAL: 'PxC_Symb-Additional',
  PROHIBITION: 'PxC_Symb-Prohibition',
  WARNING: 'PxC_Symb-Warning',
  GHS: 'PxC_Symb-GHS',
  MANDATORY: 'PxC_Symb-Mandatory',
};
export const NO_PRINTER_ID = 0;
export const BM_PRINTER_ID = 5;

export const DEFAULT_COLOR = '#000000';
export const SUCCESS = 'SUCCESS';
export const LOADING = 'LOADING';
export const INITIAL = 'INITIAL';
export const REQUEST_STATUS = {
  INITIAL,
  LOADING,
  SUCCESS,
};

export const COLOR_MODE = {
  WITHOUT_COLOR: 'WithoutColor', // draw only the borders around the elements (e.g. rectangle with no fill color but with black borders). IGNORE color property!!
  DEFINED_COLOR: 'DefinedColor', // draw the element with a background. The color is the value from color property
  VARIANT_COLOR: 'VariantColor', // use the color for the selected material variant / color (see material.variants in the original material file)
  VARIANT_ELEMENT_COLOR_OR_DEFINED_COLOR: 'VariantElementColorOrDefinedColor', // is a test element. I will remove it. → Ignore it
};

export const ACTIVE_COLOR_MODE = {
  ENABLE_BORDER: 'EnableBorder', // if the user has selected a cell fill cell in group color and draw a black border
  DISABLE_BORDER: 'DisableBorder', // if the user has selected a cell fill cell in group color and don´t draw a border. So no border!
};

export const INACTIVE_COLOR_MODE = {
  ARTICLE_COLOR_WITH_BORDER: 'ArticleColorWithBorder', // If user has not selected a cell fill the cell in article / variant color and draw a black border
  ARTICLE_COLOR_WITHOUT_BORDER: 'ArticleColorWithoutBorder' // If user has not selected a cell fill the cell in article / variant color and don´t draw a border. So no border!
};

export const TEXTFIELDMATRIX = 'TEXTFIELDMATRIX';

export const ZOOM = 1.0;

export const PAGINATION_PAGE_SIZE = 1;

export const STROKE_DASHARRAY = '0.25,0.25,0.25';
export const STROKE_WIDTH = 0.1;

export const MATRIX_CELL_WIDTH = 5.2;
export const MATRIX_SEPARATOR_WIDTH = 0.5;

export const SECTION_CONTENT_TYPE = {
  BARCODE: 'BARCODE',
  IMAGE: 'IMAGE',
  SYMBOL: 'SYMBOL',
  TEXT: 'TEXT',
  SHAPE: 'SHAPE',
};

export const INTERACTIVE_SVG_ID = 'renderer-svg';

export const SECTION_SUFFIX = '---';

export const DEFAULT_GRAPHIC_SCALE = 0.95;